import React, { useState } from "react";
import logo from "../assets/Stack.png";
import { HiMenu, HiX } from "react-icons/hi";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-white shadow z-50">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Stackness" className="h-8 w-8" />
          <h1 className="font-bold text-lg text-indigo-700">Stackness</h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-4 text-gray-700">
          <a href="#features" className="hover:text-indigo-500">Features</a>
          <a href="#pipeline" className="hover:text-indigo-500">Pipeline</a>
          <a href="#contact" className="hover:text-indigo-500">Contact</a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4 text-gray-700 flex flex-col space-y-2 bg-white shadow">
          <a href="#features" onClick={() => setMenuOpen(false)} className="hover:text-indigo-500">Features</a>
          <a href="#pipeline" onClick={() => setMenuOpen(false)} className="hover:text-indigo-500">Pipeline</a>
          <a href="#contact" onClick={() => setMenuOpen(false)} className="hover:text-indigo-500">Contact</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
